import _get from "lodash/get";
import { SchemaTypes } from "@ai4/form-viewer";
import $schema from "./generi.schema.json";
import {
  filterDefault,
  pathToSlug,
} from "src/@bootstrap/components/Crud/helpers";

import { gql, useDataRequest } from "@ai4/data-request";
import { isMobile } from "react-device-detect";
import { textFilter } from "@ai4/react-bootstrap-table2-filter";

let schema = $schema as SchemaTypes.Schema;

// export const QUERY = gql`
//   query getGeneri {
//     bibliotecaQuery {
//       generi {
//         list {
//           uniqueId
//           nome
//         }
//       }
//     }
//   }
// `;

export const SAVE = gql`
  mutation addGenere($data: GenereInput) {
    bibliotecaMutation {
      genere {
        salva(genere: $data) {
          uniqueId
          nome
        }
      }
    }
  }
`;

export const DELETE = gql`
  mutation deleteGenere($uniqueId: String) {
    bibliotecaMutation {
      genere {
        elimina(uniqueId: $uniqueId)
      }
    }
  }
`;

export interface ModuleListOptions {
  isLista?: boolean;
}

export const useModule = (options: ModuleListOptions) => {
  const list = "bibliotecaQuery.generi.list";
  const mutation = "bibliotecaMutation.genere";
  const { useLazyQuery, useQuery, useMutation } = useDataRequest();
  // const query = useLazyQuery(QUERY);
  // const [execDetails, { data: dataDetails, loading }] = query;
  const [execSave, resSave] = useMutation(SAVE, {
    refetchQueries: [pathToSlug(list)],
  });
  const [execDelete, resDelete] = useMutation(DELETE, {
    refetchQueries: [pathToSlug(list)],
  });

  return {
    graphql: {
      list,
      mutation,
      // loading,
      save: execSave,
      remove: execDelete,
      // details: execDetails,
    },
    schema,
    results: {
      save: resSave,
      remove: resDelete,
    },
    // dataDetails,
    extra: {
      options: {
        closeWhenSaved: true,
      },
    },
    table: {
      columns: [
        {
          dataField: "uniqueId",
          text: "ID",
          hidden: true,
        },
        {
          dataField: "nome",
          text: "Nome",
          filter: textFilter(filterDefault()),
        },
      ],
      dateNascoste: isMobile || options.isLista,
    },
  };
};
